import { useNavigate, useParams } from 'react-router-dom';

import TableCell from "../../../Components/Table/TableCell";
import TableContainer from "../../../Components/Table/TableContainer";
import TableFooter from "../../../Components/Table/TableFooter";
import TableHeader from "../../../Components/Table/TableHeader";
import TableSkeleton from '../../../Components/Table/TableSkeleton';
import { useBuildingService } from '../../../Services/Building/BuildingService';

import styles from "./building.list.module.css";

export default function BuildingList() {
  const { id } = useParams();
  const navigate = useNavigate();
  const {buildings} = useBuildingService(id);

  const StatusBar = ({ successPercent, errorPercent, notRegisteredPercent }) => {
    return (
      <div className={styles.bar}>
        <div className={styles.success} style={{ width: `${successPercent}%` }}/>
        <div className={styles.default} style={{ width: `${errorPercent}%` }}/>
        <div className={styles.error} style={{ width: `${notRegisteredPercent}%` }}/>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <TableContainer>
        <TableHeader>
          <TableCell th="Название ЖК"/>
          <TableCell th="Адрес"/>
          <TableCell th="Кол. домов/пом."/>
          <TableCell th="Статус"/>
        </TableHeader>
        <tbody>
        {buildings?.map((x) =>
          <tr onClick={() => navigate(`/building/edit/${x.Id}`)}>
            <TableCell title={`ЖК «${x.Name}»`} subtitle={x.UlSubject?.name}/>
            <TableCell title={x.Address?.Note}/>
            <TableCell title={x.House?.length}/>
            <TableCell th={<StatusBar errorPercent={10} notRegisteredPercent={20} successPercent={70}/>}/>
          </tr>
        )}
        {buildings?.length === 0 &&
           <TableSkeleton row={4} col={10}/>
        }
        </tbody>
        <TableFooter/>
      </TableContainer>
    </div>
  )
}